"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _basicForm = require("./basicForm");

var _basicForm2 = _interopRequireDefault(_basicForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _basicForm2.default;